import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* Pagination (kept) */
  smallPagination: {
    "& .MuiTablePagination-caption": { flexShrink: 0, fontSize: 12 },
    "& .MuiTablePagination-selectRoot": { fontSize: 12 },
    "& .MuiTablePagination-displayedRows": { fontSize: 12 },
    "& .MuiTablePagination-actions .MuiIconButton-root": { padding: 4 },
    "& .MuiTablePagination-actions svg": { fontSize: 16 },
  },

  /* Container & table */
  tableContainer: {
    boxShadow: 'none',
  },
  table: {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
  },
  tableHead: {
    backgroundColor: '#fff',
    height: 40,
  },

  /* Header cells */
  tableHeaderCell: {
    padding: 8,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 80,
    border: '1px solid rgba(233, 235, 245, 1)',
  },
  firstHeaderCell: {
    borderTopLeftRadius: 8,
  },
  lastHeaderCell: {
    borderTopRightRadius: 8,
  },
  actionHeaderCell: {
    width: 50,
  },

  /* Body cells */
  tableCell: {
    padding: 8,
    border: '1px solid rgba(233, 235, 245, 1)',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },

  /* Inline content inside a cell */
  cellContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  },
  cellText: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },
  inlineIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
  },

  /* Action column */
  actionIcon: {
    width: 25,
    height: 25,
    cursor: 'pointer',
  },
  actionIcon1: {
    width: 24,
    height: 24,
    cursor: 'pointer',
  },
  actionCell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  /* ================== Responsiveness ================== */

  /* ≤1440px */
  '@media (max-width:1440px)': {
    tableHead: { height: 38 },
    tableHeaderCell: { fontSize: 12, maxWidth: 72, padding: 8 },
    tableCell: { fontSize: 12, maxWidth: 190, padding: 8 },
    cellText: { fontSize: 12, maxWidth: 190 },
  },

  /* ≤1280px */
  '@media (max-width:1280px)': {
    tableHead: { height: 36 },
    tableHeaderCell: { fontSize: 11, maxWidth: 64, padding: 6 },
    tableCell: { fontSize: 11, maxWidth: 170, padding: 6 },
    cellContent: { gap: 6 },
    cellText: { fontSize: 11, maxWidth: 170 },
    inlineIcon: { width: 14, height: 14 },
  },

  /* ≤1024px */
  '@media (max-width:1024px)': {
    tableHead: { height: 34 },
    tableHeaderCell: { fontSize: 11, maxWidth: 56, padding: 6 },
    tableCell: { fontSize: 11, maxWidth: 150, padding: 6 },
    cellContent: { gap: 6 },
    cellText: { fontSize: 11, maxWidth: 150 },
    actionIcon: { width: 22, height: 22 },
  },
}));

export default useStyles;
